import { error_type } from "@infoland/api-proxy";
import storeHelper from "../store/store-helper";
import i18n from "../plugins/i18n";
import { ServerErrorResult } from "@infoland/iprova-api";
export default class SnackBarService {
    public static async setMessage(errorType: error_type, statusCode: string, errorNo?: number): Promise<void> {
        switch (errorType) {
            case error_type.service_desk: {
                storeHelper.siteStore.setSnackBarMessage(
                    i18n
                        .t("general.messages.errorInternalServerError", {
                            error_number: errorNo
                        } as ServerErrorResult)
                        .toString(),
                    true
                );
                break;
            }
            case error_type.general: {
                // general message with the status code
                storeHelper.siteStore.setSnackBarMessage(
                    i18n
                        .t("general.messages.errorApi", {
                            responseCode: statusCode
                        })
                        .toString(),
                    true
                );
                break;
            }
            default: {
                throw new Error(`Flow not implemented for error type: ${errorType}`);
            }
        }
    }
}
